<svg width="100%" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13.9346 11.3562L6.80202 16.4509C5.69891 17.2389 4.16663 16.4503 4.16663 15.0947L4.16663 4.90533C4.16663 3.54971 5.69891 2.76116 6.80202 3.5491L13.9346 8.64379C14.8652 9.30849 14.8652 10.6915 13.9346 11.3562Z" fill="#006BFF"/>
</svg>
